import React, { Component } from 'react';
import b from 'b_';

import './researcher-page.css';

import PublicationPageStub from './researcher-page.stub';

import { Researcher } from '@interfaces/researchers-page';
import PublicationsPage from '@interfaces/publications-page';
import paginationWrapper, { ShowMore, PaginationWrapperProps } from '@components/pagination-wrapper';
import Breadcrumbs from '@components/breadcrumbs';
import PageMeta from '@components/page-meta';
import PublicationItem from '@components/publication-item';

export interface DispatchProps {
    fetchPage(page: number): void;
    fetchResearcher(id: number): void;
}

export interface StateProps {
    publications: { [id: number]: PublicationsPage };
    data: Researcher;
    isLoading: boolean;
    isLoadingResearcher: boolean;
    match?: any;
}

type Props = StateProps & DispatchProps & PaginationWrapperProps;

import { meta as listMeta } from '../researcher-list/page-config.json';
const class_ = b.with('researcher-page');

class ResearcherPage extends Component<Props> {
    public componentDidMount() {
        const { fetchResearcher, match, data } = this.props;

        if (!data || data.id !== parseInt(match.params.id, 10)) {
            fetchResearcher(match.params.id);
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const { match, fetchResearcher, fetchPage } = this.props;
        if (match.params.id !== prevProps.match.params.id) {
            fetchResearcher(match.params.id);
            fetchPage();
        }
    }

    public shouldComponentUpdate() {
        return true;
    }

    public getList() {
        const { publications, match } = this.props;

        return publications[match.params.id] || { rows: [], meta: {} };
    }

    /* tslint:disable-next-line */
    public render() {
        const { data, isLoading, isLoadingResearcher, displayShowMore, onClick } = this.props;
        const showMoreProps = { displayShowMore, isLoading, onClick };
        const list = this.getList();

        if ((isLoading && !list.rows.length) || isLoadingResearcher || !data || !data.id) {
            return (<PublicationPageStub />);
        }
        const { firstName, lastName, photo, jobPosition, jobPlace, about } = data;

        const title = `${firstName} ${lastName}`;
        const breadcrumbs = [
            { text: 'People', url: '/people' },
            { text: title }
        ];

        return (
            <div className={class_()}>
                <PageMeta title={`${title} - People`} description={about || listMeta.description} />
                <Breadcrumbs items={breadcrumbs} hideHome />
                <div className={class_('header')}>
                    <h1 className={class_('title')}>
                        {title}
                    </h1>
                    <img className={class_('image')} src={photo || '/no-avatar.png'} />
                    <div className={class_('job')}>
                        {jobPosition && <span className={class_('job-item')}>{jobPosition}</span>}
                        {jobPlace && <span className={class_('job-item')}>{jobPlace}</span>}
                    </div>
                </div>
                {about &&
                    <div className={class_('about')}>{about}</div>
                }
                <div className="block__separator" />

                {Boolean(list.rows.length) && (
                    <div>
                        <div className="block__title">
                            Publications
                        </div>
                        {list.rows.map(event =>
                            <PublicationItem
                                type="horizontal"
                                key={event.id}
                                entity={event}
                            />
                        )}
                        <ShowMore {...showMoreProps} />
                    </div>
                )}
            </div>
        );
    }
}

export default paginationWrapper(
    ResearcherPage,
    (props: StateProps) => props.publications[props.match.params.id] || { rows: [], meta: {} }
);
